import apiClient from './apiClient';

const buildFormData = (data = {}) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null && key !== 'file') {
      formData.append(key, value);
    }
  });

  if (data.file) {
    formData.append('document', data.file);
  }

  return formData;
};

const documentsService = {
  getAll: async (page = 1, limit = 10, filters = {}) => {
    const params = new URLSearchParams({
      page,
      limit,
      ...filters
    });

    const response = await apiClient.get(`/employee-documents?${params}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/employee-documents/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/employee-documents', buildFormData(data), {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.put(`/employee-documents/${id}`, buildFormData(data), {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/employee-documents/${id}`);
    return response.data;
  }
};

export default documentsService;
